import Tooltip from "../../components/Shared/Tooltips";


export default function ActionTextButton({ onClick, text, disabled = false }) {

    return (
        <button
            onClick={onClick}
            type="button"
            disabled={disabled}
            className="relative inline-flex items-center px-2 py-2 bg-white text-sm font-medium text-gray-500 hover:bg-gray-100 disabled:text-gray-300 disabled:cursor-not-allowed focus:z-10 focus:outline-none focus:ring-1 focus:ring-etpink-500 focus:border-etpink-500"
        >
            <span>{text}</span>
        </button>
    )
}
